import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-2 col-sm-6" }
const _hoisted_6 = { class: "form-group mb-4" }
const _hoisted_7 = { value: null }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-lg-2 col-sm-6" }
const _hoisted_10 = { class: "form-group mb-4" }
const _hoisted_11 = { class: "col-lg-2 col-sm-6" }
const _hoisted_12 = { class: "form-group mb-4" }
const _hoisted_13 = { class: "col-lg-2 col-sm-6" }
const _hoisted_14 = { class: "form-group mb-4" }
const _hoisted_15 = { value: null }
const _hoisted_16 = { value: "true" }
const _hoisted_17 = { value: "false" }
const _hoisted_18 = { class: "col-lg-4 col-sm-6 text-end mt-4" }
const _hoisted_19 = { class: "d-inline-flex flex-wrap gap-2 justify-content-end" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "dropdown" }
const _hoisted_22 = { class: "dropdown-menu bg-primary" }
const _hoisted_23 = { class: "default-table-area style-two default-table-width" }
const _hoisted_24 = { class: "table-responsive" }
const _hoisted_25 = { class: "table align-middle" }
const _hoisted_26 = { class: "text-body" }
const _hoisted_27 = { class: "text-body" }
const _hoisted_28 = { class: "text-body text-center" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "text-body" }
const _hoisted_31 = { class: "text-body" }
const _hoisted_32 = { class: "text-body" }
const _hoisted_33 = { class: "text-body" }
const _hoisted_34 = { class: "text-center" }
const _hoisted_35 = { class: "" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "p-4 pt-lg-4" }
const _hoisted_38 = {
  id: "mdlBulkloadTeams",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "mdlBulkloadTeamsLabel",
  "aria-hidden": "true",
  size: "large"
}
const _hoisted_39 = { class: "modal-dialog modal-lg" }
const _hoisted_40 = { class: "modal-content" }
const _hoisted_41 = { class: "modal-body" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-lg-6 col-sm-6" }
const _hoisted_44 = { class: "form-group mb-4" }
const _hoisted_45 = ["value"]
const _hoisted_46 = {
  key: 0,
  class: "input-error"
}
const _hoisted_47 = { class: "col-lg-6 col-sm-6" }
const _hoisted_48 = { class: "form-group mb-4" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-lg-6 col-sm-6" }
const _hoisted_51 = { class: "form-group mb-4" }
const _hoisted_52 = {
  key: 0,
  class: "input-error"
}
const _hoisted_53 = { class: "modal-footer" }
const _hoisted_54 = {
  id: "mdlBulkloadTeamPlayers",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "mdlBulkloadTeamPlayersLabel",
  "aria-hidden": "true",
  size: "large"
}
const _hoisted_55 = { class: "modal-dialog modal-lg" }
const _hoisted_56 = { class: "modal-content" }
const _hoisted_57 = { class: "modal-body" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-lg-6 col-sm-6" }
const _hoisted_60 = { class: "form-group mb-4" }
const _hoisted_61 = {
  key: 0,
  class: "input-error"
}
const _hoisted_62 = { class: "col-lg-6 col-sm-6" }
const _hoisted_63 = { class: "form-group mb-4" }
const _hoisted_64 = { class: "modal-footer" }
const _hoisted_65 = {
  id: "mdlJugadores",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "mdlJugadoresLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  size: "large"
}
const _hoisted_66 = { class: "modal-dialog modal-xl" }
const _hoisted_67 = { class: "modal-content" }
const _hoisted_68 = { class: "modal-header" }
const _hoisted_69 = {
  class: "modal-title fs-5",
  id: "mdlJugadoresLabel"
}
const _hoisted_70 = { class: "modal-body" }
const _hoisted_71 = { class: "position-relative mb-3" }
const _hoisted_72 = {
  key: 0,
  class: "dropdown-menu show w-100 mt-1"
}
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { class: "default-table-area style-two default-table-width" }
const _hoisted_75 = { class: "table-responsive" }
const _hoisted_76 = { class: "table align-middle" }
const _hoisted_77 = { class: "text-center" }
const _hoisted_78 = { class: "form-check form-switch" }
const _hoisted_79 = ["onUpdate:modelValue", "onChange"]
const _hoisted_80 = { class: "text-center" }
const _hoisted_81 = { class: "" }
const _hoisted_82 = ["onClick"]
const _hoisted_83 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayLoader = _resolveComponent("OverlayLoader")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_FilePond = _resolveComponent("FilePond")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_OverlayLoader, { visible: _ctx.isLoading }, null, 8 /* PROPS */, ["visible"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            class: "position-relative table-src-form me-0",
            onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", { class: "label text-secondary" }, "Empresa/Institución", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.companyId) = $event)),
                    class: "form-select form-control h-55",
                    "aria-label": "Default select example"
                  }, [
                    _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsCompany, (item, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: i
                      }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_8))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.companyId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", { class: "label text-secondary strong" }, "Torneo", -1 /* HOISTED */)),
                  _createCommentVNode(" <v-select\r\n                  v-if=\"itemsTournament && itemsTournament.length > 0\"\r\n                  v-model=\"filters.tournamentIds\"\r\n                  :options=\"\r\n                    itemsTournament.map((t) => ({ label: t.name, value: t.id }))\r\n                  \"\r\n                  :multiple=\"true\"\r\n                  placeholder=\"-- TODOS --\"\r\n                /> "),
                  _createVNode(_component_Multiselect, {
                    modelValue: _ctx.filters.tournamentIds,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.tournamentIds) = $event)),
                    mode: "tags",
                    placeholder: "-- TODOS --",
                    options: 
                    _ctx.itemsTournament.map((t) => ({ value: t.id, label: t.name }))
                  
                  }, null, 8 /* PROPS */, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", { class: "label text-secondary" }, "Nombre", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.name) = $event)),
                    class: "form-control h-55",
                    placeholder: "Ingrese nombre"
                  }, null, 512 /* NEED_PATCH */), [
                    [
                      _vModelText,
                      _ctx.filters.name,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", { class: "label text-secondary" }, "Estado Registro", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.isActive) = $event)),
                    class: "form-select form-control h-55",
                    "aria-label": "Default select example"
                  }, [
                    _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                    _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.STATUS.ACTIVE), 1 /* TEXT */),
                    _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.STATUS.INACTIVE), 1 /* TEXT */)
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.isActive]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => {
                    _ctx.currentPage = 1;
                    _ctx.getTeams(_ctx.currentPage);
                  }, ["prevent"])),
                    class: "btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                  }, " Buscar "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.exportToExcel && _ctx.exportToExcel(...args)), ["prevent"])),
                    class: "btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg",
                    disabled: _ctx.isLoading
                  }, _toDisplayString(_ctx.isLoading ? "Exportando..." : "Exportar"), 9 /* TEXT, PROPS */, _hoisted_20),
                  _createVNode(_component_RouterLink, { to: "/team/create" }, {
                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg"
                      }, [
                        _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                          _createElementVNode("span", null, "Agregar Equipo")
                        ])
                      ], -1 /* HOISTED */)
                    ])),
                    _: 1 /* STABLE */
                  }),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      id: "dropdownCargaMasiva",
                      class: "btn btn-primary text-white py-2 dropdown-toggle",
                      type: "button",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
                      "aria-expanded": "false"
                    }, _cache[27] || (_cache[27] = [
                      _createElementVNode("span", { class: "py-sm-1" }, " Carga masiva ", -1 /* HOISTED */)
                    ])),
                    _createElementVNode("ul", _hoisted_22, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item text-white",
                          href: "#",
                          onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.bulkloadTeamsModal && _ctx.bulkloadTeamsModal(...args)), ["prevent"]))
                        }, "Equipos")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item text-white",
                          href: "#",
                          onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.bulkloadTeamPlayersModal && _ctx.bulkloadTeamPlayersModal(...args)), ["prevent"]))
                        }, "Jugadores x Equipos")
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ], 32 /* NEED_HYDRATION */)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("table", _hoisted_25, [
              _cache[30] || (_cache[30] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "#"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Empresa/Institución"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Torneos"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Equipo"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode("Nro. "),
                    _createElementVNode("br"),
                    _createTextVNode("Jugadores")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Estado Registro"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode(" Creado"),
                    _createElementVNode("br"),
                    _createTextVNode(" por ")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode("Fecha "),
                    _createElementVNode("br"),
                    _createTextVNode("creación")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode("Modificado "),
                    _createElementVNode("br"),
                    _createTextVNode("por")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode(" Fecha "),
                    _createElementVNode("br"),
                    _createTextVNode(" modificación ")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Opciones")
                ])
              ], -1 /* HOISTED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1 + (_ctx.currentPage - 1) * _ctx.pageSize), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_26, _toDisplayString(item.company.name), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_27, _toDisplayString(item.tournament.name), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.name), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.numberPlayers), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_28, [
                      _createElementVNode("span", {
                        onClick: ($event: any) => (_ctx.confirmChangeStatus(item.id, item.isActive)),
                        class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.computeStatusClass(item.isActive)]),
                        role: "button"
                      }, _toDisplayString(item.isActive ? _ctx.STATUS.ACTIVE : _ctx.STATUS.INACTIVE), 11 /* TEXT, CLASS, PROPS */, _hoisted_29)
                    ]),
                    _createElementVNode("td", _hoisted_30, _toDisplayString(item.createdBy), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_31, _toDisplayString(item.createdAtDateTimeString), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_32, _toDisplayString(item.updatedBy), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_33, _toDisplayString(item.updatedAtDateTimeString), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_RouterLink, {
                          to: `/team/edit/${item.id}`
                        }, {
                          default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                            _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " edit ", -1 /* HOISTED */)
                          ]))]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                        _createElementVNode("button", {
                          class: "ps-2 border-0 bg-transparent lh-1 position-relative",
                          onClick: ($event: any) => (
                        _ctx.teamPlayersModal(item.id, item.id)
                      )
                        }, [...(_cache[29] || (_cache[29] = [
                          _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " sports_kabaddi ", -1 /* HOISTED */)
                        ]))], 8 /* PROPS */, _hoisted_36)
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_Pagination, {
              currentPage: _ctx.currentPage,
              pageSize: _ctx.pageSize,
              totalItems: _ctx.totalItems,
              "onUpdate:page": _ctx.fetchPage
            }, null, 8 /* PROPS */, ["currentPage", "pageSize", "totalItems", "onUpdate:page"])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Modal Carga Masiva Equipos"),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", {
              class: "modal-title fs-5",
              id: "mdlBulkloadTeamsLabel"
            }, " Carga Masiva de Equipos "),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _cache[32] || (_cache[32] = _createElementVNode("label", { class: "label text-secondary strong" }, "Torneo", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formBulkloadTeams.tournamentId) = $event)),
                    onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.clearError('tournamentId'))),
                    class: "form-select form-control h-45",
                    "aria-label": "Default select example"
                  }, [
                    _cache[31] || (_cache[31] = _createElementVNode("option", { value: null }, "-- Seleccionar --", -1 /* HOISTED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsTournament, (item, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: i
                      }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_45))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelSelect, _ctx.formBulkloadTeams.tournamentId]
                  ]),
                  (_ctx.errors.tournamentId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.errors.tournamentId), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("label", null, [
                    _createElementVNode("a", {
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.downloadFile())),
                      class: "col-md-8"
                    }, _cache[33] || (_cache[33] = [
                      _createElementVNode("u", {
                        class: "text-primary",
                        style: {"cursor":"pointer"}
                      }, "Descargar Plantilla", -1 /* HOISTED */)
                    ]))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _cache[34] || (_cache[34] = _createElementVNode("label", { class: "label text-secondary strong" }, "Archivo", -1 /* HOISTED */)),
                  _createVNode(_component_FilePond, {
                    name: "teamDataFile",
                    maxFileSize: '20MB',
                    "accepted-file-types": _ctx.supportedFormats,
                    "allow-multiple": "false",
                    "max-files": 1,
                    "label-idle": "Arrastra tu archivo o <span class='filepond--label-action'>Buscar</span>",
                    labelMaxFileSizeExceeded: 'El archivo es demasiado grande',
                    labelMaxFileSize: 'El tamaño máximo permitido es {filesize}',
                    labelFileTypeNotAllowed: 'El archivo tiene una extensión no permitida',
                    fileValidateTypeLabelExpectedTypes: `El tipo de archivo permitido es: .xlsx`,
                    credits: "",
                    onUpdatefiles: _ctx.handleUpdateFiles,
                    onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.clearError('teamDataFile')))
                  }, null, 8 /* PROPS */, ["accepted-file-types", "onUpdatefiles"]),
                  (_ctx.errors.teamDataFile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_ctx.errors.teamDataFile), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary text-white",
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args)))
            }, " Guardar "),
            _cache[35] || (_cache[35] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger text-white",
              "data-bs-dismiss": "modal"
            }, " Cerrar ", -1 /* HOISTED */))
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Modal Carga Masiva Jugadores "),
    _createElementVNode("div", _hoisted_54, [
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _cache[40] || (_cache[40] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", {
              class: "modal-title fs-5",
              id: "mdlBulkloadTeamPlayersLabel"
            }, " Carga Masiva de Jugadores por Equipos "),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _cache[37] || (_cache[37] = _createElementVNode("label", { class: "label text-secondary strong" }, "Archivo", -1 /* HOISTED */)),
                  _createVNode(_component_FilePond, {
                    name: "teamDataFile",
                    maxFileSize: '20MB',
                    "accepted-file-types": _ctx.supportedFormats,
                    "allow-multiple": "false",
                    "max-files": 1,
                    "label-idle": "Arrastra tu archivo o <span class='filepond--label-action'>Buscar</span>",
                    labelMaxFileSizeExceeded: 'El archivo es demasiado grande',
                    labelMaxFileSize: 'El tamaño máximo permitido es {filesize}',
                    labelFileTypeNotAllowed: 'El archivo tiene una extensión no permitida',
                    fileValidateTypeLabelExpectedTypes: `El tipo de archivo permitido es: .xlsx`,
                    credits: "",
                    onUpdatefiles: _ctx.handleUpdateFilesBulkloadTeamPlayers,
                    onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.clearErrorBulkloadTeamPlayers('teamDataFile')))
                  }, null, 8 /* PROPS */, ["accepted-file-types", "onUpdatefiles"]),
                  (_ctx.errorsBulkloadTeamPlayers.teamDataFile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.errorsBulkloadTeamPlayers.teamDataFile), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("label", null, [
                    _createElementVNode("a", {
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.downloadFileBulkloadTeamPlayers())),
                      class: "col-md-8"
                    }, _cache[38] || (_cache[38] = [
                      _createElementVNode("u", {
                        class: "text-primary",
                        style: {"cursor":"pointer"}
                      }, "Descargar Plantilla", -1 /* HOISTED */)
                    ]))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary text-white",
              onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.validateFormBulkloadTeamPlayers && _ctx.validateFormBulkloadTeamPlayers(...args)))
            }, " Guardar "),
            _cache[39] || (_cache[39] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger text-white",
              "data-bs-dismiss": "modal"
            }, " Cerrar ", -1 /* HOISTED */))
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Modal Jugadores Equipo"),
    _createElementVNode("div", _hoisted_65, [
      _createElementVNode("div", _hoisted_66, [
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("h1", _hoisted_69, " Equipo " + _toDisplayString(_ctx.teamEdit.name) + " - Jugadores ", 1 /* TEXT */),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
              "aria-label": "Close"
            })
          ]),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.searchQuery) = $event)),
                onInput: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.fetchResults && _ctx.fetchResults(...args))),
                type: "text",
                class: "form-control",
                placeholder: "Escribe para buscar jugadores..."
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, _ctx.searchQuery]
              ]),
              (_ctx.showDropdown && _ctx.results.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_72, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.id,
                        class: "dropdown-item",
                        onClick: ($event: any) => (_ctx.selectItem(item))
                      }, _toDisplayString(item.fullName), 9 /* TEXT, PROPS */, _hoisted_73))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("table", _hoisted_76, [
                  _cache[43] || (_cache[43] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { scope: "col" }, "#"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Nombres"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Apellidos"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Alias"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Capitán"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Opciones")
                    ])
                  ], -1 /* HOISTED */)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamPlayers, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(index + 1), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.firstName), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.lastName), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.alias), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_77, _toDisplayString(item.isCaptainStr), 1 /* TEXT */),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_78, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              role: "switch",
                              id: "flexSwitchCheckDefault",
                              "onUpdate:modelValue": ($event: any) => ((item.isCaptain) = $event),
                              onChange: ($event: any) => (
                            _ctx.confirmChangeCaptain(item.id, item.isCaptain)
                          )
                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_79), [
                              [_vModelCheckbox, item.isCaptain]
                            ]),
                            _cache[41] || (_cache[41] = _createElementVNode("label", {
                              class: "form-check-label",
                              for: "flexSwitchCheckDefault"
                            }, null, -1 /* HOISTED */))
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_80, [
                          _createElementVNode("div", _hoisted_81, [
                            _createElementVNode("button", {
                              class: "ps-2 border-0 bg-transparent lh-1 position-relative",
                              onClick: ($event: any) => (_ctx.deletePlayerTeam(item.id))
                            }, [...(_cache[42] || (_cache[42] = [
                              _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " delete ", -1 /* HOISTED */)
                            ]))], 8 /* PROPS */, _hoisted_82)
                          ])
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger text-white",
              onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, " Cerrar ")
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}